import React from "react";
import {
  CoreFlightSteps,
  FlightsNavigationFlow,
} from "@b2bportal/core-utilities";
import { useReviewPageContainer, useReviewPageRoute } from "@tenant/flights";

export const useReviewPage = () => {
  useReviewPageRoute();
  const goToNextStep = FlightsNavigationFlow.useGoToNextStep(
    CoreFlightSteps.REVIEW
  );

  const goToStep = FlightsNavigationFlow.useGoToStep();
  const goToSearch = React.useCallback(
    () => goToStep(CoreFlightSteps.SEARCH),
    [goToStep]
  );

  return useReviewPageContainer({
    goToNextStep,
    onError: goToSearch,
  });
};
